












import { Vue, Component, Prop } from "vue-property-decorator";
import { mapActions } from "vuex";
import { authToken } from "@/utils/user";

@Component({
  methods: {
    ...mapActions("filters", ["updateFilterIsNotificationEnabled"])
  }
})
export default class NotificationSettingsSwitch extends Vue {
  updateFilterIsNotificationEnabled;

  /**
   * A filter object
   */
  @Prop({ type: Object, required: true }) filter!: any;

  /**
   * The key of the notification type that should set.
   */
  @Prop({ type: String, default: "isPushEnabled" }) notificationType?:
    | "isPushEnabled"
    | "isNotificationEnabled";

  /**
   * @returns {Boolean} If notification are enabled for the given type
   */
  get isEnabled(): boolean {
    return this.filter[this.notificationType];
  }

  /**
   * Persists the setting to the API.
   *
   * NB: The current store action need 2 settings as params, therfore merging
   * defaults before adding the new value.
   */
  set isEnabled(value) {
    const notificationSettings = {
      isNotificationEnabled: this.filter.isNotificationEnabled,
      isPushEnabled: this.filter.isPushEnabled,
      [this.notificationType]: value
    };

    this.updateFilterIsNotificationEnabled({
      id: this.filter.id,
      ...notificationSettings,
      authJWT: authToken(this)
    });
  }
}
